/**
 * Where a native-app bearer token would live. On the web we use the httpOnly session cookie, so this
 * returns null. Phase 4 swaps in a Capacitor secure-storage (Keychain/Keystore) implementation.
 */
let memoryToken: string | null = null;
export const sessionToken = {
  get: (): string | null => memoryToken,
  set: (t: string | null) => {
    memoryToken = t;
  },
};
export const isNativeApp = false;
